"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, Car, TrainFront, ExternalLink } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocationAndDirections() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="standort-anreise" className="bg-background py-24 lg:py-32 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className={`max-w-3xl mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-foreground mb-6">
            Standort & Anreise
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl">Besuche mich im Herzen von Zürich. Ein Ort, der speziell dafür geschaffen wurde, dir Abstand vom Alltag zu bieten.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-start">
          {}
          <div className={`relative w-full aspect-square md:aspect-[4/3] lg:aspect-square bg-muted rounded-2xl overflow-hidden transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <img src="https://proper-salmon-1.10web.cloud/wp-content/uploads/2026/04/Bildschirmfoto-2026-04-28-um-16.56.36.png" alt="Karte Standort Wandelherz in Zürich" className="absolute inset-0 w-full h-full object-cover grayscale opacity-80 hover:opacity-100 transition-opacity duration-700" />
            {}
            <div className="absolute inset-0 bg-primary/5 mix-blend-overlay pointer-events-none"></div>
            
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
              
              
            </div>
          </div>

          {}
          <div className={`flex flex-col justify-center h-full transition-all duration-1000 delay-400 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-8 mb-12">
              <div className="flex items-start gap-4">
                <div className="bg-muted p-3 rounded-full shrink-0">
                  <MapPin className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-2">
                    Adresse
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">Wandelherz<br />Universitätstrasse 100<br />8006 Zürich, Schweiz</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-muted p-3 rounded-full shrink-0">
                  <Phone className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-2">
                    Telefon
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">+41 76 371 73 78</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-muted p-3 rounded-full shrink-0">
                  <Mail className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-2">
                    E-Mail
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">renata.wandelherz@gmail.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-muted p-3 rounded-full shrink-0">
                  <Clock className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-2">
                    Öffnungszeiten
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Montag: 9:00–19:00 Uhr<br />
                    Dienstag: Geschlossen<br />
                    Mittwoch: Geschlossen<br />
                    Donnerstag: 9:00–19:00 Uhr<br />
                    Freitag: 9:00–19:00 Uhr<br />
                    Samstag: Geschlossen<br />
                    Sonntag: Geschlossen
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t border-border pt-10">
              
              
            </div>

            <div className="mt-10">
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}